import { transformGamesWithJoinedOdds } from "../../services/UserGroup.js";
import { APP_CONFIG } from "../constants/global-variables.js";
import { filterBlockedSports } from "../../services/BlockedSports.js";
export async function getSearchGames(getSearchValue) {
  const options = {
    method: "GET",
  };

  const url = `${APP_CONFIG.URL.apiBasePath}ajax/searchmatch?q=${getSearchValue}`;

  try {
    const res = await axios.post(url, null);
    const dataTransformed = transformGamesWithJoinedOdds(res.data);
    return filterBlockedSports(
      dataTransformed,
      (game) => game?.sport_id ?? game?.sportId
    );
  } catch (err) {
    // console.log(err);
    console.log("Error getting documents", err);
  }
}
